import { Case } from '@/api/apis/case';
import { getUnosId } from '@/utils/helpers';

export const invalidateInitialCase = (cases: Case[], selectedCase: Case): string | null => {
  const isSelectedCaseInList = cases.some((c) => c.caseId === selectedCase.caseId);

  if (isSelectedCaseInList) return null;

  return getUnosId(
    selectedCase.donorId,
    selectedCase.organType,
    selectedCase.reAllocationSequenceNumber,
    selectedCase.opoRequest,
    selectedCase.isExpeditedCase,
    selectedCase.laterality,
    selectedCase.duplicateCaseNumber,
  );
};

export type InvalidateTargetCasesType = {
  caseId: string;
  unosId: string;
};

export const invalidateTargetCases = (cases: Case[], selectedCases: Case[]): InvalidateTargetCasesType[] => {
  const invalidCases = selectedCases.filter((selectedCase) => !cases.some((c) => c.caseId === selectedCase.caseId));

  return invalidCases.map((c) => ({
    caseId: c.caseId,
    unosId: getUnosId(
      c.donorId,
      c.organType,
      c.reAllocationSequenceNumber,
      c.opoRequest,
      c.isExpeditedCase,
      c.laterality,
      c.duplicateCaseNumber,
    ),
  }));
};
